var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoUserstyles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 1v16H1V6c0-1.38.56-2.63 1.464-3.536A4.984 4.984 0 0 1 6 1h7ZM13 24v7H6c-1.38 0-2.63-.56-3.536-1.464A4.984 4.984 0 0 1 1 26v-2h12ZM26 1c1.38 0 2.63.56 3.536 1.464A4.984 4.984 0 0 1 31 6v3H19V1ZM31 15v11c0 1.38-.56 2.63-1.464 3.536A4.984 4.984 0 0 1 26 31h-7V15h12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUserstyles);
export default __webpack_public_path__ + "static/media/logo-userstyles.bc30de0f5b9c1bb433f9d6b08ffedeb9.svg";
export { ForwardRef as ReactComponent };